<script>
import App from "@/pages/layouts/app.vue";
import Form from '@/pages/tags/_form.vue';
import StoreForm from "@wielink-application/shared/js/mixins/storeForm";

export default {
  mixins: [StoreForm],
  components: {App, Form},
  data() {
    return {
      formRoute: route('api.v1.knowledge_base.tags.store'),
      redirectRoute: route('knowledge_base.tags.index'),
      stayOnPageRedirect: route('knowledge_base.tags.edit', {tag: '_id_'}),
    }
  },
}
</script>

<template>
  <App title="Label toevoegen">
    <form id="tagForm" @submit.prevent="submit">
      <Form ref="form"/>
    </form>

    <template #bottomButtons>
      <FormButtons
          form-id="tagForm"
          @backToOverview="stayOnPage = 0"
          :loading="loading"
          :cancel-route="redirectRoute"
      />
    </template>
  </App>
</template>